import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getDeathDeclaration, getDocuments } from "../../../../../actions/facilita-api";
import { getRelocationDeclaration } from "../../../../../actions/events-api";
import { useParams } from "react-router-dom";
import * as R from "ramda";

import { FileTypes } from "../../../../../constants/utils/fileTypes";

// Declarer
// ==========================================
// Declarer: Common
// import { Help } from '../../../_common/help';

import { Navbar } from "./_common/navbar";
import { Path } from "../_common/path";

// Declarer: Views
import { Step1 } from "./step1";
import { Step2 } from "./step2";
import { Step3 } from "./step3";
import { Step4 } from "./step4";

export const DeclareModal = ({ userState, relocationDeclarationState, getDeclaration, fetchLifeEvents, generateLettersForUserId }) => {
	const [onBoardingStep, setOnboardingStep] = useState();
	const [user, setUser] = useState();
	const [relocatedUser, setRelocatedUser] = useState();

	useEffect(() => {
		if (!R.isNil(relocationDeclarationState?.declaration?.onBoardingStep) && R.isNil(onBoardingStep)) {
			setOnboardingStep(relocationDeclarationState.declaration.onBoardingStep);
		}
		if (!R.isNil(userState)) {
			setUser(userState);
		}
		if (!R.isNil(userState?.user)) {
			setRelocatedUser(userState.user);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [relocationDeclarationState?.declaration?.onBoardingStep, userState, userState?.user]);

	if (R.isNil(user) || R.isNil(relocationDeclarationState) || R.isNil(relocationDeclarationState.declaration)) {
		return "";
	}

	return (
		<div className="modal fade px-0" id="declareRelocation" aria-labelledby="declareRelocationLabel" aria-hidden="true">
			<div className="modal-dialog modal-fullscreen p-3">
				<div className="modal-content">
					<div className="modal-body p-0">
						<div className={"layout layout-row" + (!R.isNil(userState.partnerCustomization) && !R.isNil(userState.partnerCustomization.color) && userState.partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{ backgroundColor: "#" + userState.partnerCustomization.color }}>
							<h1 className="sr-only visually-hidden">Assist@</h1>
							<Navbar partnerColor={userState.partnerCustomization?.color} logoContent={userState.partnerCustomization?.logoBase64Encoded} user={userState.user} relocationDeclaration={relocationDeclarationState?.declaration} onBoardingStep={onBoardingStep} setOnboardingStep={setOnboardingStep} />
							<main role="main" className="view flex-grow-1 bg-gradient-light">
								<h1 className="sr-only visually-hidden">Assist@: Main</h1>
								<div className="container-fluid flex-md-row align-items-center gap-xs pt-3">
									{/* <Help row={true} /> */}
									<Path relocatedUser={relocatedUser} />
								</div>
								{onBoardingStep == 1 && <Step1 relocationDeclaration={relocationDeclarationState.declaration} relocatedUser={relocatedUser} isLoading={relocationDeclarationState.isLoading} setOnboardingStep={setOnboardingStep} getDeclaration={getDeclaration} />}
								{onBoardingStep == 2 && (
									<Step2
										userId={userState.user.id}
										relocationDeclaration={relocationDeclarationState.declaration}
										relocatedUser={relocatedUser}
										isLoading={relocationDeclarationState.isLoading}
										setOnboardingStep={setOnboardingStep}
										getDeclaration={getDeclaration}
										serviceDatas={relocationDeclarationState.serviceDatas}
									/>
								)}
								{onBoardingStep == 3 && <Step3 userId={userState.user.id} relocationDeclaration={relocationDeclarationState.declaration} isLoading={relocationDeclarationState.isLoading} setOnboardingStep={setOnboardingStep} getDeclaration={getDeclaration} />}
								{onBoardingStep == 4 && (
									<Step4
										userId={userState.user.id}
										relocationDeclaration={relocationDeclarationState.declaration}
										isLoading={relocationDeclarationState.isLoading}
										setOnboardingStep={setOnboardingStep}
										getDeclaration={getDeclaration}
										signatureFile={relocationDeclarationState.files.find((f) => f.fileType === FileTypes.Signature)}
										fetchLifeEvents={fetchLifeEvents}
										generateLettersForUserId={generateLettersForUserId}
									/>
								)}
							</main>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
